import {NavHistoryButton} from '../NavHistoryButton';

import type {FC} from 'react';

export interface ForwardButtonProps {
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
}

export const ForwardButton: FC<ForwardButtonProps> = props => (
  <NavHistoryButton direction="forward" {...props} />
);
